const LOGO_DARK = "/mnd-logo.png";
const LOGO_LIGHT = "/mnd-logo-light.png";

export function Logo({ className = "h-11", variant = "dark" }) {
  const src = variant === "light" || variant === "white" ? LOGO_LIGHT : LOGO_DARK;
  return (
    <span className="inline-flex items-center">
      <img src={src} alt="M&D Realtors" className={className} draggable={false} />
    </span>
  );
}
